import React, {useState} from 'react';
import { Box, Button, Container, TextField, Typography } from '@mui/material';
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { Email } from '@mui/icons-material';
import { emailVerificationSchema } from '../../services/validator';
import useEncryption from "../../services/useEncryption";
import useToast from '../../helpers/useToast';
import { emailVerificationApi } from '../../api/authApi/authApi';

const EmailVerification = () => {
  const [verificationSent, setVerificationSent] = useState(false);

  const { encryptData } = useEncryption();
  const toastOptions = useToast();

  const initialValues = {
    email: '',
  };

  const validationSchema = emailVerificationSchema;

  const onSubmit = async (values) => {
    try {
      const data = encryptData(values);
      const response = await emailVerificationApi(data);
      setVerificationSent(true);
      toast.success(response.data.message,toastOptions); 
  } catch (error) {
      toast.error(error.response.data.message, toastOptions);
  }
    
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Box  sx={{ width: "100%", height: "350px", padding: "20px", border: "1px solid gray",  borderRadius: "10px", marginTop: "2%", marginBottom: "2%", boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"}}>
      <Typography variant="h4" align="center" gutterBottom sx={{color: "#2192E5 "}}>
        Verify Your Email
      </Typography>
      <Email sx={{ fontSize: 20, verticalAlign: "middle", marginLeft: "45%", width: "50px", height: "50px", color: "#F78220", marginTop: "20px", marginBottom: "20px"}}/>
          {verificationSent ? (
            <Typography variant="body2" align="center" sx={{ color: "#D29705", marginTop: 2 }}>
              If this account exists, an email will be sent for verification.
            </Typography>  
          ):(
            <form onSubmit={formik.handleSubmit}>
            <Typography variant="body1" align="center" gutterBottom sx={{color: "#8E8C89"}}>
              Please enter your email address to receive a verification link.
            </Typography>
            <Box className="input-field-section" sx={{ height: "80px"}}>
              <TextField
                fullWidth
                id="email"
                name="email"
                label="Email"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Box>
              <Button
                type="submit"
                variant="contained"
                color="success"
                fullWidth
                sx={{ mt: 2 }}
              >
                Send Verification Link
              </Button>
            </form>
          )}
      </Box>
    </Container>
  );
};

export default EmailVerification;
